import { useEffect, useState } from "react";
import api from "./api";
import { API } from "./api";

let _cache = null;
const _subs = new Set();

export async function loadBranding(force = false) {
  if (_cache && !force) return _cache;
  let data = {};
  try {
    const res = await api.get("/branding");
    data = res.data || {};
    _cache = data; // cache only on success so a pre-login 401 never poisons it
  } catch {
    // leave _cache null so the next mount (post-login) retries
  }
  _subs.forEach((fn) => fn(data));
  // Apply favicon globally if configured.
  try {
    if (data && data.favicon) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
      link.href = `${API}${data.favicon}`;
    }
  } catch { /* noop */ }
  return data;
}

// Absolute asset URL for <img> / favicon (asset route is unauthenticated brand asset).
export const assetUrl = (path) => (path ? `${API}${path}` : null);

export function useBranding() {
  const [b, setB] = useState(_cache);
  useEffect(() => {
    _subs.add(setB);
    loadBranding();
    return () => _subs.delete(setB);
  }, []);
  return b || {};
}
